<template>
	<client-only>
		<div class="header" :class="headerObj.pathName === '' ? 'header_i' : ''">
			<div class="topbox" :class="headerObj.topDistance > 80 ? 'topboxs' : ''">
				<div class="mainbox">
					<div class="logo" @click="jumpPageToUrl('')">
						<a href="javascript:void(0)">
							<img v-if="headerObj.pathName" src="@/assets/images/logo.png" />
							<img v-if="!headerObj.pathName" src="@/assets/images/logo_w.png" />
						</a>
					</div>
					<div class="topnav">
						<ul class="topnav_ul">
							<li>
								<a href="javascript:void(0)" :class="headerObj.pathName === '' ? 'on' : ''" @click="jumpPageToUrl('')">{{ t('detail.zhuye') }}</a>
							</li>
							<li>
								<a href="javascript:void(0)" :class="headerObj.pathName === 'contactUs' ? 'on' : ''" @click="jumpPageToUrl('contactUs')">{{ t('tipMsg.lianxiwomen') }}</a>
							</li>
							<li>
								<a href="javascript:void(0)" :class="headerObj.pathName === 'help' ? 'on' : ''" @click="jumpPageToUrl('help')">{{ t('home.changjianwenti') }}</a>
							</li>
							<li v-if="isShowMyBooking" class="my_booking">
								<a href="javascript:void(0)" :class="headerObj.pathName === 'orderList' ? 'on' : ''" @click="jumpPageToUrl('orderList')">{{ t('home.wodeyuding') }}</a>
								<span v-if="orderNoArr > 0" class="order_num">{{ orderNoArr }}</span>
							</li>
						</ul>
					</div>
					<div class="topbox_r">
						<div class="toptool">
							<div v-if="isShowSelectLanguage" :class="isShowSelectCurrency ? 'toplang' : 'toplang radius_right'">
								<div class="tit ep_t" @click="headerObj.setLanguageRef(true)">
									<img :src="getAssetsCurrencyFile(languageInfoVo.languageObjList[languageInfoVo.selectLanguage]?.icon)" />
									{{ languageInfoVo.languageObjList[languageInfoVo.selectLanguage]?.desc }}
								</div>
								<el-popover
									v-model:visible="headerObj.isShowLanguage"
									popper-class="con ep_m cancel_top"
									trigger="click"
									:title="t('home.yuyan')"
									:offset="100"
									transition="el-zoom-in-center"
									virtual-triggering
									persistent
									:teleported="false"
								>
									<ul>
										<li v-for="item in languageInfoVo.languageList" :key="item.code" @click="handleChangeLanguage(item.code)">
											<a href="javascript:void(0)" :class="languageInfoVo.selectLanguage === item.code ? 'on' : ''">
												<img :src="getAssetsCurrencyFile(item.icon)" />
												{{ item.desc }}
											</a>
										</li>
									</ul>
								</el-popover>
							</div>
							<div v-if="isShowSelectCurrency" class="topmoney">
								<div class="tit ep_t" @click="headerObj.setCurrencyRef(true)">
									<img :src="getAssetsCurrencyFile(currencyInfoVo.selectCurrency)" />
									{{ currencyInfoVo.selectCurrency }}
								</div>
								<el-popover
									v-model:visible="headerObj.isShowCurrency"
									popper-class="con ep_m cancel_top"
									trigger="click"
									:title="t('home.bizhong')"
									transition="el-zoom-in-center"
									virtual-triggering
									persistent
									:teleported="false"
								>
									<ul>
										<li v-for="item in currencyInfoVo.currencyList" :key="item.code + ''" @click="handleChangeCurrency(item)">
											<a href="javascript:void(0)" :class="currencyInfoVo.selectCurrency === item.code ? 'on' : ''">
												<img :src="getAssetsCurrencyFile(item.code)" />
												{{ item.code }}
											</a>
										</li>
									</ul>
								</el-popover>
							</div>
						</div>
						<div v-if="!headerObj.loginUserName" class="topuser">
							<a href="javascript:void(0)" class="btn" @click="handleGoLogin">
								<span class="tconfont tt-user"></span>
								{{ t('home.denglu') }}
							</a>
						</div>
						<div v-if="headerObj.loginUserName" class="topuser">
							<a href="javascript:void(0)" class="btn btn-show" :class="headerObj.isShowPersonCenter ? 'active' : ''" @click="headerObj.setShowPersonCenter(true)">
								<span class="tconfont tt-user"></span>
								{{ headerObj.loginUserName.length > 10 ? headerObj.loginUserName.substr(0, 9) + '...' : headerObj.loginUserName }}
								<el-popover
									v-model:visible="headerObj.isShowPersonCenter"
									popper-class="ep_m cancel_top personal"
									trigger="click"
									transition="el-zoom-in-center"
									virtual-triggering
									persistent
									:teleported="false"
								>
									<ul>
										<li v-for="item in convertPersonCenter(t)" :key="item + ''" :class="headerObj.pathName === item.url ? 'on' : ''" @click="jumpPageToUrl(item.url)">
											<a href="javascript:void(0)" :class="headerObj.pathName === item.url ? 'on' : ''">
												{{ item.name }}
											</a>
										</li>
									</ul>
								</el-popover>
							</a>
							<a href="javascript:void(0)" class="btn" @click="handleLogOut">
								<span class="tconfont tt-exit"></span>
								{{ t('member.zhuxiao') }}
							</a>
						</div>
					</div>
				</div>
			</div>
			<login-form v-if="headerObj.isShowLogin" ref="loginFormRef" @closeLoginPop="closeLoginPop" @immediateRegister="immediateRegister"></login-form>
			<register-form v-if="headerObj.isShowRegister" @closeRegisterPop="closeRegisterPop" @handleGoLogin="handleGoLogin"></register-form>
		</div>
	</client-only>
</template>

<script lang="ts" setup>
//@ts-ignore
import { onMounted, onUnmounted, reactive, watch, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRoute } from 'vue-router';
import loginForm from './login.vue';
import registerForm from './register.vue';
import { routeGo, changeLanguageRoute } from '@/hooks/web/jumpGo';
import { ElMessageBox } from 'element-plus';
import { getCurrencyListData, getLanguageListData, memberLogoutLoFun } from '@/logic/header';
import { useMessage } from '@/components/Message/index'; // 自定义封装的message
import { HeaderCurrencyInfo, HeaderNewLanguageInfo, NewHeader, type CurrencyListObj } from '@/logic/header/model';
import { loginRelatedInfo } from '@/utils/loginRelatedInfo';
import { convertLoToVo } from '@/utils/convertLoToVo';
import { getAccountFun, getChannelCid, getSelectCurrency, getUsernameFun } from '@/store/locale';
import { convertPersonCenter } from '@/enums/headerEnum';
import { getHomeScrollTopFun } from '@/store/home';
import { getAssetsCurrencyFile } from '@/utils/getImgUrl';
import { getOrderNoListStrFun } from '@/store/forever';
import { useNuxtApp } from 'nuxt/app';
import { getOrderPendingPayApiFun } from '@/logic/member';
const { $eventBus } = useNuxtApp();
const { t, locale } = useI18n();
const route = useRoute();
const loginFormRef = ref();
// 语言切换跳转页面
// @ts-ignore
const localeRoute = useLocaleRoute();
const isShowSelectCurrency = ref<boolean>(false);
const isShowSelectLanguage = ref<boolean>(false);
const isShowMyBooking = ref(false);
// 是否展示语言
const headerObj = reactive(new NewHeader());
const currencyInfoVo = reactive(new HeaderCurrencyInfo());
const languageInfoVo = reactive(new HeaderNewLanguageInfo());
const orderNoArr = ref(0);
console.log('出发header刷新');
onMounted(async () => {
	// 币种接口
	const currencyInfoLo = await getCurrencyListData(getChannelCid());
	convertLoToVo(currencyInfoVo, currencyInfoLo);
	// 语言接口
	const languageInfoLo = await getLanguageListData(locale.value.toLowerCase(), getSelectCurrency());
	convertLoToVo(languageInfoVo, languageInfoLo);
	//@ts-ignore
	// 验价时触发的登录
	//@ts-ignore
	$eventBus.on('priceVerifyLogin', () => {
		headerObj.isShowLogin = true;
		setTimeout(() => {
			loginFormRef.value.currentLoginDataFun('verifyPrice');
		}, 50);
	});
});
// 跳转
const jumpPageToUrl = (url: string) => {
	routeGo(url);

	setTimeout(() => {
		headerObj.isShowPersonCenter = false;
	}, 0);
};
// 切换语言
const handleChangeLanguage = (language: string) => {
	changeLanguageRoute(route, localeRoute, language);
	languageInfoVo.selectLanguage = language;
	languageInfoVo.changeSelectLanguage(language);
	getLanguageListData(language.toLowerCase(), getSelectCurrency());
	headerObj.setLanguageRef(false);
	setTimeout(() => {
		let chatwootLang = {
			Cn: 'zh_CN',
			En: 'en',
			Hk: 'zh_TW',
			Ja: 'ja',
		}[language];
		// @ts-ignore
		window.$chatwoot.setLocale(chatwootLang);
	}, 1500);
};

// 切换币种
const handleChangeCurrency = (item: CurrencyListObj) => {
	let queryString = '';
	if (route.params.fromCity) {
		let queryMap = new Map(Object.entries(route.query));
		queryMap.delete('currency');
		let queryObj = Object.fromEntries(queryMap);
		queryString = objectToQueryString(queryObj);
	}
	if (item.domain) {
		if (process.client) {
			//@ts-ignore
			location.href = `${item.domain}${route.path}?${queryString}currency=${item.code}`;
		}
	} else {
		currencyInfoVo.selectCurrency = item.code;
		currencyInfoVo.changeSelectCurrency(item.code);
		headerObj.setCurrencyRef(false);
	}
};
// 转换对象为string
function objectToQueryString(obj: any) {
	// 初始化一个空字符串用于存储最终的querystring
	let querystring = '';
	// 遍历对象的每个键值对
	for (let key in obj) {
		if (obj.hasOwnProperty(key)) {
			// 将键值对转换为"key=value"的格式，并添加到querystring中
			querystring += encodeURIComponent(key) + '=' + encodeURIComponent(obj[key]) + '&';
		}
	}
	return querystring;
}
// 登录
function closeLoginPop() {
	headerObj.isShowLogin = false;
}
// 立即注册
function immediateRegister() {
	headerObj.isShowRegister = true;
}
// 关闭注册
function closeRegisterPop() {
	headerObj.isShowRegister = false;
}
// 去登录
function handleGoLogin() {
	headerObj.isShowLogin = true;
}
// 注销登录
function handleLogOut() {
	ElMessageBox.confirm(t('member.quedingyaodengchuma'), t('sys.tiShi'), {
		confirmButtonText: t('addPsg.queren'),
		cancelButtonText: t('addPsg.quxiao'),
		type: '',
	})
		.then(async () => {
			let res = await memberLogoutLoFun();
			if (res.status === 0) {
				loginRelatedInfo();
				jumpPageToUrl('');
				useMessage().success(t('member.tuichuchenggong'));
			}
		})
		.catch(() => {});
}
async function getOrderPendingPayFun() {
	let data: any = undefined;
	if (getOrderNoListStrFun()) {
		data = getOrderNoListStrFun();
	}
	let res = await getOrderPendingPayApiFun({ data });
	if (res.status === 0) {
		orderNoArr.value = res.data;
	}
}
/**
 *route  监听路由变化修改导航菜单tab显示
 * 监听getUsername 获取用户名
 *监听getHomeScrollTop  获取滚动位置
 */
watch(
	[() => route, () => getAccountFun(), () => getHomeScrollTopFun()],
	val => {
		if (val.length > 0) {
			if (val[0].fullPath) {
				let pathArr = val[0].fullPath.split('/');
				if (pathArr.length > 1) {
					if (pathArr[2]) {
						headerObj.pathName = pathArr[2];
					} else {
						headerObj.pathName = '';
					}
				}
			}
			if (val[0].meta) {
				isShowSelectCurrency.value = val[0].meta.isShowSelectCurrency as boolean;
				isShowSelectLanguage.value = val[0].meta.isShowSelectLanguage as boolean;
			}
			headerObj.setLoginUserName(val[1]);
			headerObj.setTopDistance(Number(val[2]));
		}
		let lang = route.path.split('/')[1];
		if (lang !== languageInfoVo.selectLanguage) {
			languageInfoVo.selectLanguage = lang;
			languageInfoVo.changeSelectLanguage(lang);
			setTimeout(() => {
				let chatwootLang = {
					Cn: 'zh_CN',
					En: 'en',
					Hk: 'zh_TW',
					Ja: 'ja',
				}[lang];
				// @ts-ignore
				window.$chatwoot.setLocale(chatwootLang);
			}, 1500);
			if (lang) {
				getLanguageListData(lang.toLowerCase(), getSelectCurrency());
			}
		}
	},
	{
		immediate: true,
		deep: true,
	}
);
onUnmounted(() => {
	//@ts-ignore
	$eventBus.off('priceVerifyLogin');
});
watch(
	() => [getOrderNoListStrFun(), getUsernameFun()],
	val => {
		isShowMyBooking.value = false;
		if (val[0]) {
			isShowMyBooking.value = true;
		}
		if (val[1]) {
			if (val[1] !== 'Guest') {
				isShowMyBooking.value = true;
			}
		}
	},
	{
		immediate: true,
		deep: true,
	}
);
watch(
	() => route,
	() => {
		getOrderPendingPayFun();
	},
	{
		immediate: true,
		deep: true,
	}
);
</script>
<style lang="scss" scoped>
.radius_right {
	border-radius: 20rem;
}
:deep(.personal) {
	width: auto !important;
	padding: 10rem 0 !important;
	ul {
		li {
			padding: 10rem;
			position: relative;
			&.on {
				background-color: #f5f7fc;
				&::before {
					content: '';
					width: 5rem;
					height: 100%;
					background: #3180ff;
					position: absolute;
					left: 0;
					top: 0;
				}
			}
			a {
				display: block;
				white-space: nowrap;
				text-align: left;
				padding: 0 10rem;
				.person_img {
					width: 26rem;
					height: 26rem;
					vertical-align: middle;
					border: 1px solid #ddd;
					border-radius: 50%;
					padding: 2rem;
				}
				&.on {
					color: #3180ff;
				}
			}
		}
	}
}
.my_booking {
	position: relative;
	.order_num {
		position: absolute;
		width: 15rem;
		height: 15rem;
		font-size: 10rem;
		color: #fff;
		border-radius: 50%;
		line-height: 15rem;
		text-align: center;
		background: red;
		top: 25rem;
		right: 3rem;
	}
}
</style>
